<div>
  <table class="-mx-6 -mb-6 table">
    <thead>
    <tr>
      <th *ngIf="selectable" class="bg-gray-50 px-6">
        <app-checkbox *ngIf="list && list.length > 0" [formControl]="selectAllControl"></app-checkbox>
      </th>
      <th *ngFor="let column of columns" class="text-xxs font-semibold text-gray-900 px-6 py-4 text-left bg-gray-50">
        {{ column.label | translate }}
      </th>
      <th class="text-xxs font-semibold text-gray-900 px-6 py-4 text-right bg-gray-50">
        {{ 'table.actions' | translate }}
      </th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let row of list" [class.cursor-pointer]="row.link" [class.opacity-60]="row.isArchived" [routerLink]="row.link ? row.link : null">
      <td *ngIf="selectable" class="px-6 py-4 text-left border-b border-b-gray-100">
        <app-checkbox [formControl]="getSelectionControlForItem(row)"></app-checkbox>
      </td>
      <td *ngFor="let column of columns" class="text-sm text-gray-900 px-6 py-4 text-left border-b border-b-gray-100">
        <ng-container *ngIf="!column.date && !column.color">{{ extractProperty(row, column.name) }} {{ column.suffix! | translate }}</ng-container>
        <ng-container *ngIf="column.date">{{ extractProperty(row, column.name) | date:'dd-MM-YYYY HH:mm' }}</ng-container>
        <ng-container *ngIf="column.color">
          <div class="w-5 h-5 rounded-full border border-gray-300" [style.background]="extractProperty(row, column.name)"></div>
        </ng-container>
      </td>
      <td width="5%" class="text-right border-b border-b-gray-100">
        <div class="flex justify-end gap-1 px-6 py-4" *ngIf="row.link || hasDelete">
          <app-button-icon *ngIf="row.link" icon="/assets/images/icon-detail.svg" [routerLink]="row.link"></app-button-icon>
          <app-button-icon *ngIf="hasDelete" icon="/assets/images/icon-trash.svg" (click)="delete.next(row)"></app-button-icon>
        </div>
      </td>
    </tr>
    <tr *ngIf="list?.length !== 0 && !list">
      <td [attr.colspan]="columns.length + 1" class="py-2 text-primary-one">
        <div class="flex justify-center items-center">
          <app-loader></app-loader>
        </div>
      </td>
    </tr>
    <tr *ngIf="list?.length === 0">
      <td [attr.colspan]="columns.length + (selectable ? 2 : 1)" class="px-6 py-4 text-left text-xs text-gray-500">
        {{ 'table.no-data' | translate }}
      </td>
    </tr>
    </tbody>
    <tfoot>
    <tr [class.opacity-0]="list?.length !== 0 && !list">
      <td [attr.colspan]="columns.length + (selectable ? 2 : 1)" class="px-6 py-4 text-left text-xs text-gray-500">
        <div class="flex justify-end gap-4 items-center">
          <span *ngIf="isPageResponse">Showing {{ (pageResponse.number * pageResponse.size + 1) }}-{{ (pageResponse.number + 1) * pageResponse.size }} of {{ pageResponse?.totalElements }}</span>
          <span *ngIf="!isPageResponse">Showing 1-{{ list?.length }} of {{ list?.length }}</span>

          <div class="flex gap-1" *ngIf="isPageResponse">
            <app-button-icon icon="/assets/images/icon-chevron-left-gray.svg" [disabled]="pageResponse.first" (click)="previousPage()"></app-button-icon>
            <app-button-icon icon="/assets/images/icon-chevron-right-gray.svg" [disabled]="pageResponse.last" (click)="nextPage()"></app-button-icon>
          </div>
        </div>
      </td>
    </tfoot>
  </table>
</div>
